// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_m0-0";
export var animationContainer = "_m0-1";
export var itemPrice = "_m0-a";
export var itemizedContent = "_m0-9";
export var itemizedHeader = "_m0-7";
export var itemizedRow = "_m0-8";
export var itemizedSection = "_m0-6";
export var modalContent = "_m0-2";
export var orderName = "_m0-3";
export var refundOption = "_m0-4";
export var refundOptionsContainer = "_m0-5";
export var shippingLabel = "_m0-b";
export var totalRow = "_m0-c";